<template>
  <div class="list">
    <div style="text-align: right">
      <el-button @click="openWondeLogs" type="primary">Logs</el-button>
      <el-button @click="openModal('checkEmailModal')" type="primary">Test Email</el-button>
      <el-button @click="openModal('newSchoolModal')" type="primary">+ Add new School</el-button>
      <el-button @click="openModal('newTestUserModal')" type="primary">+ Add new test User</el-button>
    </div>
    <hr />
    <el-table :data="data" style="width: 100%" :default-sort="{ prop: 'name', order: 'ascending' }" v-loading="loading">
      <el-table-column prop="id" label="Id" sortable width="80"></el-table-column>
      <el-table-column prop="name" label="Name" sortable></el-table-column>
      <!-- <el-table-column
        prop="provider"
        label="Provider"
        sortable
      ></el-table-column> -->
      <el-table-column prop="provider_school_id" label="provider id" sortable></el-table-column>
      <el-table-column prop="organization_id" label="organization_id"></el-table-column>
      <el-table-column prop="multiple_schools" label="multiple_schools"></el-table-column>
      <el-table-column prop="notes" label="Notes"></el-table-column>
      <!-- <el-table-column label="Stats">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="
              openStats(scope.row.id, scope.row.name, scope.row.content_type)
            "
            >Stats
          </el-button>
        </template>
</el-table-column> -->
      <el-table-column prop="created_at" label="Created" sortable class-name="smallFont"></el-table-column>
      <el-table-column prop="updated_at" label="Updated" sortable class-name="smallFont"></el-table-column>
      <el-table-column prop="last_synced_at" label="Last data sync" sortable class-name="smallFont"></el-table-column>
      <el-table-column label="Actions" width="160">
        <template slot-scope="scope">
          <el-button :loading="syncingData && syncingData == scope.row.organization_id" size="mini" type="warning"
            title="Sync data" @click="syncSchoolData(scope.row.organization_id)"><i class="fas fa-sync"></i>
          </el-button>
          <el-button :loading="syncingData && syncingData == scope.row.organization_id" size="mini" type="warning"
            title="Wonde stats for school" @click="loadWondeStats(scope.row.organization_id)"><i
              class="fas fa-bar-chart"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <modal name="newSchoolModal" :height="'auto'">
      <h3 style="padding-left: 20px">Add new school</h3>
      <div class="row">
        <div class="" style="padding: 0 30px">
          <el-form>
            <el-form-item label="Name">
              <el-input v-model="form.name" placeholder="name"></el-input>
            </el-form-item>
            <el-form-item label="Provider school id">
              <el-input v-model="form.provider_school_id" placeholder="provider_school_id"></el-input>
            </el-form-item>
            <el-form-item label="school_id">
              <el-input v-model="form.organization_id" placeholder="organization_id"></el-input>
            </el-form-item>
            <el-form-item label="token">
              <el-input v-model="form.token" placeholder="token" required></el-input>
            </el-form-item>
            <el-form-item label="Multiple schools">
              <el-input v-model="form.multiple_schools" placeholder="multiple_schools separate with comma"
                required></el-input>
            </el-form-item>
            <el-form-item label="notes">
              <el-input v-model="form.notes" placeholder="notes"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div style="text-align: center">
        <el-button type="primary" :disabled="!this.form.name ||
          !this.form.organization_id ||
          !this.form.provider_school_id ||
          !this.form.token
          " @click="addSchool" round style="margin-bottom: 10px">Submit</el-button>
        <el-button plain @click="$modal.hide('newSchoolModal')" round style="margin-bottom: 10px">Close</el-button>
      </div>
    </modal>
    <modal name="newTestUserModal" :height="'auto'">
      <h3 style="padding-left: 20px">Add new test user</h3>
      <div class="row">
        <div class="" style="padding: 0 30px">
          <el-form>
            <el-form-item label="Title">
              <el-select v-model="newTestUserForm.title" placeholder="please select title">
                <el-option label="Mrs" value="Mrs"></el-option>
                <el-option label="Miss" value="Miss"></el-option>
                <el-option label="Ms" value="Ms"></el-option>
                <el-option label="Mr" value="Mr"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Type">
              <el-select v-model="newTestUserForm.type" placeholder="please select type">
                <el-option label="Parent" value="parent"></el-option>
                <el-option label="Staff" value="staff"></el-option>
                <el-option label="Both" value="both"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="First Name">
              <el-input v-model="newTestUserForm.first_name" placeholder="first name"></el-input>
            </el-form-item>
            <el-form-item label="Last name">
              <el-input v-model="newTestUserForm.last_name" placeholder="last_name"></el-input>
            </el-form-item>
            <el-form-item label="organization_id">
              <el-input v-model="newTestUserForm.organization_id" placeholder="organization_id"></el-input>
            </el-form-item>
            <el-form-item label="email">
              <el-input v-model="newTestUserForm.email" placeholder="email" required></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div style="text-align: center">
        <el-button type="primary" :disabled="!this.newTestUserForm.first_name ||
          !this.newTestUserForm.organization_id ||
          !this.newTestUserForm.last_name ||
          !this.newTestUserForm.title ||
          !this.newTestUserForm.type ||
          !this.newTestUserForm.email
          " @click="addTestUserToWonde" round style="margin-bottom: 10px">Submit</el-button>
        <el-button plain @click="$modal.hide('newTestUserModal')" round style="margin-bottom: 10px">Close</el-button>
      </div>
    </modal>
    <modal name="checkEmailModal" :height="'auto'" width="1200">
      <div style="padding: 20px">
        <h3 style="padding-left: 20px">Check email</h3>
        <el-form>
          <el-form-item label="email">
            <el-input v-model="checkEmailForm.email" placeholder="email" required></el-input>
          </el-form-item>
          <el-form-item label="organization_id">
            <el-input v-model="checkEmailForm.school_id" placeholder="organization_id"></el-input>
          </el-form-item>
        </el-form>
        <div v-if="checkForEmail" style="margin-bottom: 20px">
          Results for {{ checkForEmail }}:
          <table>
            <thead>
              <tr>
                <th>wonde_user_id</th>
                <th>email</th>
                <th>first_name</th>
                <th>last_name</th>
                <th>status</th>
                <th>type</th>
                <th>consumed</th>
                <th>Action</th>
              </tr>
            </thead>
            <tr :key="indexa" v-for="(row, indexa) in miCheckResults">
              <td>{{ row.wonde_user_id }}</td>
              <td>{{ row.email }}</td>
              <td>{{ row.first_name }}</td>
              <td>{{ row.last_name }}</td>
              <td>{{ row.status }}</td>
              <td>{{ row.type }}</td>
              <td>{{ row.consumed }}</td>
              <td>
                <el-button @click="excludeWondeUser(row.wonde_user_id)" type="primary">Exclude user</el-button>
              </td>
            </tr>
            <tr v-if="miCheckResults.length === 0">
              <td>No results</td>
            </tr>
          </table>
        </div>
        <div style="text-align: center">
          <el-button type="primary" :disabled="!this.checkEmailForm.email
            " @click="checkEmail" round style="margin-bottom: 10px">Submit</el-button>
          <el-button plain @click="$modal.hide('newTestUserModal')" round style="margin-bottom: 10px">Close</el-button>
        </div>
        <!-- <table v-if="activeTab == 'logs'">
          <thead>
            <tr>
              <th>Action</th>
              <th>Description</th>
              <th>School id</th>
              <th>Param 1</th>
              <th>Param 2</th>
              <th>Created at</th>
            </tr>
          </thead>
          <tr :key="row.id" v-for="row in miLogs">
            <td>{{ row.action }}</td>
            <td>{{ row.description }}</td>
            <td>{{ row.school_id }}</td>
            <td>{{ row.param1 }}</td>
            <td>{{ row.param2 }}</td>
            <td>{{ row.created_at }}</td>
          </tr>
        </table> -->
      </div>
    </modal>
    <modal name="wondeStatsModal" :height="'auto'" width="1000">
      <h3 style="padding-left: 20px">
        Wonde Stats for {{ wondeStatsData.school.name || "" }}
        {{ wondeStatsData.school.id || "" }}
      </h3>
      <div class="row">
        <div class="" style="padding: 0 30px" v-loading="loadingWondeStats">
          <table>
            <thead>
              <tr>
                <th>Total staff</th>
                <th>Valid staff emails</th>
                <th>Pupils</th>
                <th>Total parents</th>
                <th>Valid parents emails</th>
                <th>Parents with parental resp</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ wondeStatsData.stats.total_staff || 0 }}</td>
                <td>{{ wondeStatsData.stats.valid_staff_emails || 0 }}</td>
                <td>{{ wondeStatsData.stats.pupils || 0 }}</td>
                <td>{{ wondeStatsData.stats.total_parents || 0 }}</td>
                <td>{{ wondeStatsData.stats.valid_parents_emails || 0 }}</td>
                <td>
                  {{
                    wondeStatsData.stats.parents_with_parental_responsibility ||
                    0
                  }}&nbsp;
                </td>
              </tr>
            </tbody>
          </table>

          <hr />

          <table>
            <thead>
              <tr>
                <th>Existing parents</th>
                <th>Exis. parents validated</th>
                <th>Exis. parents non-validated</th>
                <th>Exis. parents valid perc</th>
                <th>Exis. staff</th>
                <th>Exis. staff validated</th>
                <th>Exis. staff non-validated</th>
                <th>Exis. staff valid perc</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ wondeStatsData.stats.existing_parents || 0 }}</td>
                <td>
                  {{ wondeStatsData.stats.existing_parents_validated || 0 }}
                </td>
                <td>
                  {{ wondeStatsData.stats.existing_parents_nonvalidated || 0 }}
                </td>
                <td>
                  {{
                    wondeStatsData.stats.existing_parents_validation_perc || 0
                  }}%
                </td>

                <td>{{ wondeStatsData.stats.existing_staff || 0 }}</td>
                <td>
                  {{ wondeStatsData.stats.existing_staff_validated || 0 }}
                </td>
                <td>
                  {{ wondeStatsData.stats.existing_staff_nonvalidated || 0 }}
                </td>
                <td>
                  {{
                    wondeStatsData.stats.existing_staff_validation_perc || 0
                  }}%
                </td>
              </tr>
            </tbody>
          </table>
          <hr />
        </div>
      </div>
      <div style="text-align: center">
        <el-button plain @click="$modal.hide('wondeStatsModal')" round style="margin-bottom: 10px">Close</el-button>
      </div>
    </modal>
  </div>
</template>
<script>
import WondeLogsModal from "@/modals/WondeLogsModal";
import ApiService from "@/services/ApiService";
export default {
  name: "SchoolIntegrations",
  data() {
    return {
      keyword: "",
      showType: "",
      data: [],
      form: {},
      newTestUserForm: {},
      checkEmailForm: {},
      newSchoolModal: false,
      newTestUserModal: false,
      checkEmailModal: false,
      loading: false,
      syncingData: false,
      loadingWondeStats: false,
      activeTab: "logs",
      miLogs: [],
      checkForEmail: null,
      miCheckResults: [],
      wondeStatsData: { stats: {}, school: {} },
    };
  },
  methods: {
    getSchools() {
      ApiService.sadminApi.integrationListSchools().then((resp) => {
        this.data = resp.data;
      });
    },
    addSchool() {
      ApiService.sadminApi.integrationAddSchoolToken(this.form).then((resp) => {
        this.$notify.success({
          title: "Success",
          message: "School token has been added.",
        });
        this.form = {};
        this.getSchools();
        this.$modal.hide("newSchoolModal");
      });
    },
    addTestUserToWonde() {
      ApiService.sadminApi
        .addTestUserToWonde(this.newTestUserForm)
        .then((resp) => {
          this.$notify.success({
            title: "Success",
            message: "New test user has been added.",
          });
          this.newTestUserForm = {};
          this.$modal.hide("newTestUserModal");
        })
        .catch((e) => alert(e));
    },
    syncSchoolData(schoolId) {
      this.syncingData = schoolId;
      ApiService.sadminApi
        .integrationSyncSchoolData(schoolId)
        .then((resp) => {
          this.getSchools();
          this.$notify.success({
            title: "Success",
            message: "School has been synced.",
          });
        })
        .catch(() => {
          this.$notify.error({
            title: "Something went wrong",
            message: "Syncing failed.",
          });
        })
        .finally(() => {
          this.syncingData = false;
        });
    },
    loadWondeStats(schoolId) {
      this.openModal("wondeStatsModal");
      this.loadingWondeStats = true;
      this.wondeStatsData = { stats: {}, school: {} };
      ApiService.sadminApi
        .loadWondeStats(schoolId)
        .then((resp) => {
          if (!resp.data.school) {
            resp.data.school = { name: "", id: null };
          }
          this.wondeStatsData = resp.data;
        })
        .catch(() => {
          this.$notify.error({
            title: "Something went wrong",
            message: "Loading live wonde stats failed.",
          });
        })
        .finally(() => {
          this.loadingWondeStats = false;
        });
    },
    openModal(modalName) {
      this.$modal.show(modalName);
      if (modalName == "checkEmailModal") {
        this.loadMiLogs();
      }
    },
    openWondeLogs() {
      this.$modal.show(
        WondeLogsModal,
        {
          options: {
            profilePicture: true,
          },
          // id,
        },
        {
          draggable: false,
          transition: "fadeDown",
          scrollable: true,
          height: "auto",
          adaptive: true,
          width: "95%",
          // pivotY: 0
        },
        {}
      );
    },
    excludeWondeUser(wondeUserId) {
      ApiService.sadminApi.excludeWondeUser(wondeUserId).then((resp) => {
        this.$notify.success({
          title: "Something good happened",
          message: "Success.",
        });
      });
    },
    goto(path) {
      path = "/members/automations/" + path;
      this.$router.push(path);
    },
    loadMiLogs() {
      ApiService.sadminApi.getMiLogs().then((resp) => {
        this.miLogs = resp.data;
      });
    },
    checkEmail() {
      ApiService.sadminApi.checkMiEmail(this.checkEmailForm).then((resp) => {
        this.$notify.success({
          title: "Something good happened",
          message: "Success.",
        });
        this.checkForEmail = this.checkEmailForm.email;
        this.miCheckResults = resp.data;
      });
    },
    checkLogs() {
      ApiService.sadminApi.getMiLogs().then((resp) => {
        this.miLogs = resp.data;
      });
    },
  },
  mounted() {
    this.getSchools();
  },
};
</script>
<style scoped>
.smallFont {
  font-size: 11px;
}

table {
  border-collapse: collapse;
  width: 100%;
}

table,
th,
td {
  border: 1px solid;
}

th {
  padding: 2px 5px !important;
}

td:nth-child(even),
th:nth-child(even) {
  background-color: #d6eeee;
}
</style>
